// PLP Variant Selector - Handle image switching for B2C variant selection
if (!customElements.get('plp-variant-selector')) {
  customElements.define('plp-variant-selector', class PlpVariantSelector extends HTMLElement {
    constructor() {
      super();
      this.variantSelect = this.querySelector('.card__variant-select');
      if (!this.variantSelect) return;
      
      this.cardContainer = this.closest('.card__container');
      this.variantImages = this.cardContainer?.querySelectorAll('img[data-variant-id]');
      
      this.init();
    }

    init() {
      if (!this.variantSelect || !this.variantImages || this.variantImages.length === 0) return;
      
      // Listen for variant selection changes
      this.variantSelect.addEventListener('change', (e) => {
        const selectedVariantId = e.target.value;
        this.switchVariantImage(selectedVariantId);
      });
    }

    switchVariantImage(variantId) {
      // Hide all variant images
      this.variantImages.forEach(img => {
        img.style.opacity = '0';
      });

      // Show the selected variant image
      const selectedImage = Array.from(this.variantImages).find(
        img => img.dataset.variantId === variantId
      );

      if (selectedImage) {
        selectedImage.style.opacity = '1';
      }
    }
  });
}

// Handle variant selection via event delegation for dynamic content
document.addEventListener('change', (e) => {
  // Handle regular variant selector (fallback for products without custom dropdowns)
  if (e.target.classList.contains('card__variant-select')) {
    const cardContainer = e.target.closest('.card__container');
    if (!cardContainer) return;

    const variantImages = cardContainer.querySelectorAll('img[data-variant-id]');
    const selectedVariantId = e.target.value;

    // Hide all variant images
    variantImages.forEach(img => {
      img.style.opacity = '0';
    });

    // Show the selected variant image
    const selectedImage = Array.from(variantImages).find(
      img => img.dataset.variantId === selectedVariantId
    );

    if (selectedImage) {
      selectedImage.style.opacity = '1';
    }
  }
});
